module.exports = __webpack_public_path__ + "static/media/banner-dooshop.f2851e88.png";